<h2 mat-dialog-title>REMOVE SIA STATION</h2>
<mat-dialog-content
	>This action will REMOVE the station on SIA (this action cannot be reversed). Do
	you confirm?
	<div>Station Name: <b>{{data.name}}</b></div>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-raised-button mat-dialog-close>Cancel</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true">
		Remove
	</button>
</mat-dialog-actions>
